import { CircleButton } from '@fnacdarty/back-office-ui';
import { Panel } from 'react-resizable-panels';
import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const StyledPanelContainer = styled(Panel)`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
`;

export const StyledActivityPanelContent = styled.div`
	display: flex;
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	justify-content: center;
	overflow: hidden;
	border-radius: 0.5rem;
	margin: 20px 0 0 0;
`;
export const StyledCalendarPanelContent = styled(StyledActivityPanelContent)`
	display: flex;
	width: 100%;
	margin: auto;
	display: flex;
	flex-direction: row;
	justify-content: center;
	overflow: hidden;
	border-radius: 0.5rem;
	margin: 20px 0;
`;

export const StyledMainContainer = styled(StyledCalendarPanelContent)`
	justify-content: flex-start;
	position: relative;
	height: calc(100vh - 70px);
	margin: 0;
	flex-direction: column;
`;

export const StyledPanelDetails = styled(StyledCalendarPanelContent)`
	bottom: 0;
	height: 825px;
	width: 700px;
	padding: 10px;
	background-color: ${({ theme }) => theme.colors.background};
	margin: 0px 0px 0px 0px;
	//border: 1px solid ${({ theme }) => theme.colors.primary};
	box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
	visibility: ${({ $isVisible }) => ($isVisible ? 'visible' : 'hidden')};
	opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
	transition: visibility 0.3s, opacity 0.3s linear;
	z-index: 1000;
	flex-direction: column;
	@media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
		position: absolute;
		width: 100%;
		height: 100%;
	}
`;

export const StyledTabContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	width: 1100px;
	margin-top: 20px;
`;

export const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	width: 1100px;
	height: 100%;
`;

export const StyledHeader = styled.div`
	margin-top: 20px;
	@media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
		margin-top: 0px;
	}
	width: 1100px;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
`;

export const StyledCircleButton = styled(CircleButton)`
	@media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
		top: 20px;
	}
	right: 20px;
	color: #ffffff;
	background-color: ${({ theme }) => theme.colors.primary};
	cursor: pointer;
	&:hover {
		background-color: ${({ theme }) => theme.colors.primarylight};
	}
`;

export const StyledNavigation = styled.div`
	height: calc(100% - 70%);
`;
